<template>
  <v-item v-slot="{ active, toggle }" :value="value">
    <v-btn
      :class="getClass(active)"
      :width="width"
      :height="height"
      tile
      elevation="0"
      @click="toggle"
    >
      <slot></slot>
      <v-chip
        v-if="count !== null && count > 0"
        x-small
        class="px-2"
        :class="chipClasses(active)"
      >
        <span class="font-weight-bold">
          {{ count }}
        </span>
      </v-chip>
    </v-btn>
  </v-item>
</template>

<script>
export default {
  name: 'TabItem',
  props: {
    value: {
      type: [String, Number, Object],
      required: true,
    },
    width: {
      type: [String, Number],
      default: null,
    },
    height: {
      type: [String, Number],
      default: null,
    },
    count: {
      type: [String, Number],
      default: null,
    },
  },
  methods: {
    getClass(selected) {
      return [
        {
          primary: selected,
          ['grey lighten-3 grey--text text--darken-2']: !selected,
        },
      ];
    },
    chipClasses(selected) {
      return {
        ['ml-2 grey--text text--darken-2']: !selected,
        'ml-2 white': selected,
        ['ml-2 primary--text']: selected,
      };
    },
  },
};
</script>
